import React, { useContext } from "react";
import { Navigate, Outlet } from 'react-router-dom'
import { AuthContext } from "../context/AuthContext";
import Appbar from './Appbar'
import Drawer from "./Drawer";
import Body from "./Body";
import SubAdminTermsAndConditions from "../view/auth/SubAdminTermsAndCondtion";

// export default function AuthGuard(props) {
//   const auth = useContext(AuthContext);
//   return (
//     auth.userLoggedIn ? <Outlet /> : <Navigate to='/login' />
//   )
// }


export default function AuthGuard(props) {
  const auth = useContext(AuthContext);

  // Check if user is logged in
  if (!auth.userLoggedIn) {
    return <Navigate to='/login' />
  }
  const hasChannelPermission = auth?.userData?.roles?.some(role =>
    role.permissions?.some(permission => permission.module === "channel")
  );

  // Check if subAdmin needs to accept terms and conditions
  if (
    (auth?.userData && auth?.userData?.is_subadmin === true && hasChannelPermission) &&
    (auth?.userData?.policy_accepted === false)
  ) {
    return (
      <div>
        <SubAdminTermsAndConditions />
      </div>

    )
  }

  // If logged in and no terms needed, show the protected routes
  return <Outlet />
}